import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { WherebySdkHelperService } from '../../whereby-classroom-sdk/services/whereby-sdk-helper.service';

export interface LeaveProgramData {
    classSessionId: string;
    redirectUrl: string;
    title: string;
    isUserHost: boolean | null;
}

@Component({
    templateUrl: './leave-program.component.html',
    styleUrls: ['./leave-program.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LeaveProgramComponent {
    constructor(
        private dialogRef: MatDialogRef<LeaveProgramComponent>,
        @Inject(MAT_DIALOG_DATA) public data: LeaveProgramData,
        private sdkService: WherebySdkHelperService,
    ) {}

    leaveProgram(): void {
        this.sdkService.userWantsToLeaveProgram.emit(this.data.redirectUrl);
        this.dialogRef.close();
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
